interface SkeletonLoaderProps {
	className?: string;
	height?: string;
	width?: string;
}

export function SkeletonLoader({ className = "", height = "20px", width = "100%" }: SkeletonLoaderProps) {
	return <div className={`animate-pulse bg-neutral-200 rounded ${className}`} style={{ height, width }} />;
}

// Enhanced skeleton components for carousels
export function CarouselNavigationSkeleton({ className = "" }: { className?: string }) {
	return (
		<div className={`flex items-center justify-between px-2 py-2 bg-gray-50 border-b ${className}`}>
			{/* Previous button skeleton */}
			<div className="p-2 rounded-full bg-neutral-200 animate-pulse">
				<div className="w-4 h-4 bg-neutral-300 rounded" />
			</div>

			{/* Dots indicator skeleton */}
			<div className="flex gap-1">
				{[...Array(3)].map((_, index) => (
					<div key={index} className="w-2 h-2 rounded-full bg-neutral-300 animate-pulse" />
				))}
			</div>

			{/* Next button skeleton */}
			<div className="p-2 rounded-full bg-neutral-200 animate-pulse">
				<div className="w-4 h-4 bg-neutral-300 rounded" />
			</div>
		</div>
	);
}

export function CarouselHeaderSkeleton({ className = "" }: { className?: string }) {
	return (
		<div className={`flex items-center justify-between p-2 pt-4 border-b ${className}`}>
			<div className="flex-1">
				<div className="flex items-center gap-2 mb-1">
					{/* Project name skeleton */}
					<div className="h-5 w-48 bg-neutral-200 rounded animate-pulse" />
				</div>
				{/* Count and status skeleton */}
				<div className="h-4 w-32 bg-neutral-200 rounded animate-pulse" />
			</div>
		</div>
	);
}
